<template>
  <div class="boxRegion">
    <div v-if="warn" style="text-align: center;margin-top: 30px;"><h3>Model computation in progress, please wait...</h3></div>
    <div class="datatable" v-if="flag">
      <!--显示内容-->

      <!--列表区-->
      <el-table
        :data="datalist.slice((page - 1) * page_size, page * page_size)"
        border
        stripe
      >
        <el-table-column label="#" prop="num"></el-table-column>

        <el-table-column label="Cell Type" prop="type"></el-table-column>
        <el-table-column label="name" prop="name"></el-table-column>
      </el-table>
      <hr />
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <hr />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page_size: 10,
      page: 1,
      total: null,
      datalist: [],
      flag:false,
      warn:true
    };
  },
  methods: {
    async getData() {
      const res = await this.$http.get("cells/");
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data;
      this.total = res.data.length;
    },
    // 分页
    //监听每页显示变化
    handleSizeChange(newPage_size) {
      this.page_size = newPage_size;
      this.page = 1;
    },
    //

    //监听当前页变化
    handleCurrentChange(newPage) {
      this.page = newPage;
    },
  },
  created: function () {
    this.getData();
    setTimeout(() =>{
      if(this.datalist.length == 0){
        console.log('打印失败'),
        this.$router.go(0);
      }else{this.flag=true;this.warn=false;}
},5000);

  },
};
</script>
<style lang="less" scoped>
.el-pagination {
  display: flex;
  justify-content: center;
}
.boxRegion{
width: 1170px;
margin:auto;
}
.datatable{
  margin-top: 30px;
}

</style>
